@if (tooltip) {
  <div class="rkt-tooltip" (mouseover)="isTooltipDisplayed = true" (mouseout)="isTooltipDisplayed = false">
    <rkt-icon name="info" class="rkt-tooltip-icon"></rkt-icon>
    <div class="rkt-tooltip-message" [hidden]="!isTooltipDisplayed">{{ tooltip }}</div>
  </div>
}
